<template>
  <div class="margin-70">
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <dv-border-box-12 class="operaBox padding-sm margin-top-sm">
      <div
        class="operation flex align-center padding-tb-xs"
        v-for="(item,index) in overviewList"
        :key="index"
      >
        <div class="margin-left-sm margin-right-sm operateImg"><img
            class="operateIcon"
            :src="item.img"
          /></div>
        <img
          class="right-icon margin-lr-sm"
          src="@/assets/images/site/tri.png"
        >
        <div class="flex flex-direction">
          <p class="text-xsss">{{item.text}}</p>
          <div
            class="digitalFlop text-xxl-xl DS-font"
            :style="{'color':item.number.style.fill}"
          >{{item.number.content}}</div>
        </div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
import BigTitle from "@/components/bigTitle";
// 综合态势--动态渲染图片
import overview0 from "@/assets/images/index/overview1.png";
import overview1 from "@/assets/images/index/overview4.png";
import overview2 from "@/assets/images/index/overview2.png";
import overview3 from "@/assets/images/index/overview3.png";
import overview4 from "@/assets/images/index/overview3.png";

import { siteLeft } from "@/api/singleSite/left";
import { numChange } from '@/utils/index.js'

export default {
  data() {
    return {
      options: {},
      bigtitle: {
        CHN: "充电仓",
        ENG: "Overview",
      },
      overviewList: [
        {
          text: "额定电池数",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#36FBFB",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview2,
        },
        {
          text: "配置电池数",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#43FFB9",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview1,
        },
        {
          text: "累计换电次数",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#FFFFFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview3,
        },
        {
          text: "累计充电电量",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#179DFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview3,
        }
      ],
    };
  },
  components: {
    BigTitle,
  },
  props: {
    batteryInfo: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    batteryInfo:{
      handler(newValue,oldValue){
        if(newValue){
            let info = newValue;
          this.overviewList= [
            {
              text: "额定电池数",
              number: {
                content: info.totalBatteries||0,
                textAlign: "left",
                style: {
                  fill: "#36FBFB",
                  fontFamily: "DS-Digital-Bold",
                  fontSize: 50,
                },
              },
              img: overview2,
            },
            {
              text: "配置电池数",
              number: {
                content: info.houseTotalBatteries||"0",
                textAlign: "left",
                style: {
                  fill: "#43FFB9",
                  fontFamily: "DS-Digital-Bold",
                  fontSize: 50,
                },
              },
              img: overview1,
            },
            {
              text: "累计换电次数",
              number: {
                content: info.changePowerNum||0,
                textAlign: "left",
                style: {
                  fill: "#FFFFFF",
                  fontFamily: "DS-Digital-Bold",
                  fontSize: 50,
                },
              },
              img: overview3,
            },
            {
              text: "累计充电电量",
              number: {
                content: numChange(info.changeTotal)||"0",
                textAlign: "left",
                style: {
                  fill: "#179DFF",
                  fontFamily: "DS-Digital-Bold",
                  fontSize: 50,
                },
              },
              img: overview3,
            }
          ]
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    
  },
  methods: {
    
    
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/overview.scss";
.right-icon {
  width: 14px;
  height: 16px;
}
</style>